/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-shrink-screen-filled': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10.625 11.25H17.5c.69 0 1.25.56 1.25 1.25v3.75c0 .69-.56 1.25-1.25 1.25h-6.875c-.69 0-1.25-.56-1.25-1.25V12.5c0-.69.56-1.25 1.25-1.25zm-3.125-5v2.241L4.817 5.808l-.884.884 2.683 2.683H4.375v1.25H8.75V6.25H7.5zm.625 7.5H2.5c-.69 0-1.25-.56-1.25-1.25V4.375c0-.69.56-1.25 1.25-1.25h13.75c.69 0 1.25.56 1.25 1.25V10h-1.25V4.375H2.5V12.5h5.625v1.25z"/>'
  }
})
